import styled from "styled-components";
import {
  siteDarkBlue,
  siteYellow,
  siteLightBlue,
  sitePurple,
  siteDarkGreen,
  siteGray
} from "../../providers/Theme";

export const ImpactSection = styled.section<{ $variant?: string }>`
  background: ${({ $variant }) => ($variant === "flat" ? "white" : siteGray)};
  padding: 4rem 1.5rem;
  text-align: center;
`;

export const SectionHeading = styled.h2`
  color: ${siteDarkBlue};
  font-weight: 800;
  font-size: 2rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 0.75rem;

  ${({ theme }) => theme.md`
    font-size: 2.5rem;
  `}
`;

export const SectionSubtitle = styled.p`
  color: ${siteDarkBlue};
  font-size: 1.35rem;
  max-width: 44rem;
  margin: 0 auto 2.5rem;
  line-height: 1.6;

  ${({ theme }) => theme.md`
    font-size: 1.5rem;
  `}
`;

export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 1.25rem;
  max-width: 72rem;
  margin: 0 auto;
`;

export const StatCard = styled.div<{ $variant?: string }>`
  background: white;
  border-radius: 12px;
  border: ${({ $variant }) => ($variant === "flat" ? "1.5px solid #c8d4e8" : "none")};
  padding: 2.25rem 1.5rem 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 180px;
  flex-shrink: 0;

  ${({ theme }) => theme.md`
    width: 210px;
  `}
`;

export const CardIcon = styled.div<{ color: string }>`
  margin-bottom: 1rem;
  line-height: 1;

  img {
    width: 5rem;
    height: 5rem;
    object-fit: contain;
  }
`;

export const StatNumber = styled.p<{ color: string }>`
  color: ${({ color }) => color};
  font-weight: 800;
  font-size: 1.85rem;
  line-height: 1.1;
  margin-bottom: 0.5rem;
`;

export const StatLabel = styled.p`
  color: ${siteDarkBlue};
  font-size: 1.15rem;
  line-height: 1.4;
  margin: 0;
`;

export const cardColors = {
  purple: sitePurple,
  darkBlue: siteDarkBlue,
  lightBlue: siteLightBlue,
  green: siteDarkGreen,
  yellow: siteYellow
};
